export default __webpack_public_path__ + "static/media/back_to_top.95379a96.svg";